<mat-form-field
  appearance="outline"
  [floatLabel]="floatLabel"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>

  <div style="display: flex">
    <div *ngIf="control.disabled">
      <span>{{ phoneNumber }}</span>
    </div>

    <div [hidden]="control.disabled">
      <input
        matInput
        type="text"
        [formControl]="control"
        [placeholder]="placeholder"
        pattern="^[6-9][0-9]{9}$"
        inputmode="numeric"
        (ngModelChange)="inputChanged($event)"
        maxlength="10"
        (keypress)="validateKeyPress($event)"
      />
    </div>
  </div>

  <mat-error>
    <ng-content select="[error]"></ng-content>
  </mat-error>
</mat-form-field>
